import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import './ConsultaSelectionModal.css';
import { ReactComponent as NoProfileIcon } from "../Assets/padrao.svg";


ReactModal.setAppElement('#root');

const ConsultaSelectionModal = ({ isOpen, onRequestClose, medico, consultas, onAgendar }) => {
    const [selectedConsultaId, setSelectedConsultaId] = useState('');


    useEffect(() => {
        if (isOpen) {
            setSelectedConsultaId('');
        }
    }, [isOpen]);

    const handleAgendarClick = () => {
        if (selectedConsultaId) {
            const consultaSelecionada = consultas.find(c => c && c._id != null && String(c._id) === String(selectedConsultaId));
            if (consultaSelecionada) {
                console.log("[Modal] Consulta selecionada encontrada:", consultaSelecionada);
                onAgendar(medico, consultaSelecionada);
            } else {
                console.error("[Modal] Erro: Consulta selecionada não encontrada com ID:", selectedConsultaId);
                alert("Ocorreu um erro ao encontrar os detalhes da consulta selecionada. Tente novamente.");
            }
        } else {
            alert("Por favor, selecione uma consulta antes de agendar.");
        }
    };

    const formatarDataHora = (dataString, horaString) => {
        const data = new Date(dataString);
        const dia = String(data.getUTCDate()).padStart(2, '0');
        const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
        const ano = data.getUTCFullYear();
        const dataFormatada = `${dia}/${mes}/${ano}`;
        return `${dataFormatada} às ${horaString}`;
    };

    if (!medico) return null;

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            overlayClassName="consulta-overlay"
            className="consulta-modal-content"
        >
            <div className="modal-header">
                {medico.fotoUrl ? (
                    <img
                        src={medico.fotoUrl}
                        alt={`Foto de ${medico.nome}`}
                        className="tm-card-photo"
                        onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                    />
                ) : (
                    <NoProfileIcon className="tm-card-photo" />
                )}
                <h3 className="modal-medic-name">
                    {medico.genero === "Masculino" ? "Dr. " : "Dra. "}
                    {medico.nome}
                </h3>
                <p className="modal-medic-crm">
                    {medico.especialidade === "Nutricionista" 
                        ? `CRN: ${medico.crm}` 
                        : medico.especialidade === "Biomédico" 
                        ? `CRBM: ${medico.crm}` 
                        : medico.especialidade === "Fisioterapeuta"
                        ? `Crefito: ${medico.crm}`
                        : (medico.especialidade === "Psicólogo" || medico.especialidade === "Psicóloga")
                        ? `CRP: ${medico.crm}`
                        : medico.especialidade === "Psiquiatria"
                        ? `RQE: ${medico.crm}`
                        : `CRM: ${medico.crm}`}
                </p>
            </div>

            <div className="modal-body">
                <h4>Selecione a consulta desejada:</h4>
                {consultas.length > 0 ? (
                    <select
                        className="consulta-select"
                        value={selectedConsultaId}
                        onChange={(e) => setSelectedConsultaId(e.target.value)}
                    >
                        <option value="">
                            Selecione uma data
                        </option>
                        {consultas.map((consulta) => (
                            <option key={consulta._id} value={consulta._id}>
                                {formatarDataHora(consulta.dataConsulta, consulta.horaConsulta)} - R$ {consulta.valorConsulta},00
                            </option>
                        ))}
                    </select>
                ) : (
                    <p>Não há consultas futuras disponíveis para este médico.</p>
                )}
            </div>

            <div className="modal-buttons">
                <button className="btn cancel" onClick={onRequestClose}>Cancelar</button>
                <button
                    className="btn confirm"
                    onClick={handleAgendarClick}
                    disabled={!selectedConsultaId}
                >
                    Agendar Consulta
                </button>
            </div>
        </ReactModal>
    );
};

export default ConsultaSelectionModal;